<template>
  <el-card class="box-card">
    <div class="main">
      <el-form inline class="global-form">
        <el-form-item prop="machineryName">
          <el-input v-model="searchForm.machineryName" clearable placeholder="请输入机械名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <el-button class="mb10" icon="el-icon-plus" @click="$router.push('/laborManageList/taiBanMachine/add')"
        type="primary" v-show="$ButtonShow('YMC_ADD_01')">新增</el-button>

      <el-table v-loading="loading" :data="tableData" class="global-table" stripe max-height="550px">
        <el-table-column label="机械名称" show-overflow-tooltip prop="machineryName"></el-table-column>
        <!-- <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"> -->
        <!-- <template v-slot="{ row }">
            <span>{{row.projectState === '3' ? getState(row.projectState) + '—' + row.projectName : row.projectName}}</span>
          </template>
</el-table-column> -->
        <el-table-column label="规格/型号" show-overflow-tooltip prop="specificationModel"></el-table-column>
        <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName"></el-table-column>
        <el-table-column label="含税单价（元）" show-overflow-tooltip prop="unitPrice"></el-table-column>
        <el-table-column label="是否含油" show-overflow-tooltip prop="whetherOil">
          <template v-slot="{ row }">
            <span>{{ row.whetherOil === '1' ? '是' : row.whetherOil === '2' ? '否' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/laborManageList/taiBanMachine/detail?machineryId=' + row.machineryId)">查看</el-button>
            <el-button type="text"
              @click="$router.push('/laborManageList/taiBanMachine/edit?machineryId=' + row.machineryId)"
              v-show="$ButtonShow('YMC_EDT_01') && row.projectState !== '3'">编辑</el-button>
            <el-button type="text" @click="onDelete(row.machineryId)" v-show="$ButtonShow('YMC_DEL_01')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
    </div>
  </el-card>
</template>

<script>
// @KeepAlive
export default {
  data () {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        machineryName: '' // 机械名称
      }
    }
  },

  created () {
    this.loadData()
  },
  methods: {
    // 获取机械表格
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.material.selectYhMachineryByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

    // 查询
    onSearch () {
      this.page = 1
      this.loadData()
    },

    // 删除机械
    onDelete (machineryId) {
      this.$confirm('确认删除该机械吗？', '提示').then(() => {
        this.$axios.post(this.$apis.material.deleteYhMachinery, {
          machineryId
        }).then(() => {
          this.$message.success('删除成功!')
          this.loadData()
        })
      })
    },

    getState (state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    }
  }

}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 0px 10px;
}
</style>
